<template>
  <div class="mainDiv" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="wav-view-container">
      <el-main>
        <el-row class="tool-bar tool-bar-search-conditions">
          <span @click="toggleShowSearchConditions">
            {{ this.$root.htmlConst.cons_319_search_condition }}
            <i :class="showSearchConditions ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </span>
        </el-row>
        <!-- 检索条件区域 -->
        <div class="search-conditions-container" v-if="showSearchConditions">
          <div class="search-conditions">
            <!-- 检索条件 - 第1行: チケット#, テキスト検索, 区分，緊急,IN/OUT/内線 -->
            <div class="search-condition row-1">
              <div class="flex-item search-ticket">
                <span class="label">{{this.$root.htmlConstRecording.cons_305_ticket_no}}</span>
                <el-input v-model="ticketNo" placeholder="#番号を入力" class="input-ticket"></el-input>
              </div>
              <div class="flex-item search-keyword">
                <span class="label">{{this.$root.htmlConstRecording.cons_105_tag_search_text_jp}}</span>
                <el-input v-model="textSearch" @keydown.enter.native="inputKeyDown($event)" placeholder="テキストを入力" clearable class="input-text-search"></el-input>
              </div>
              <div class="flex-item search-urgent">
                <span class="label">{{this.$root.htmlConst.cons_312_table_header_urgent}}</span>
                <el-checkbox v-model="isUrgent" class="check-style"></el-checkbox>
              </div>
              <div class="flex-item search-escalation">
                <span class="label">{{this.$root.htmlConstRecording.cons_106_tag_escalation}}</span>
                <el-checkbox v-model="isEscalation" class="check-style"></el-checkbox>
              </div>
              <div class="flex-item in-out-internal-phone-call">
                <span class="label-padding-right-10">{{this.$root.htmlConstRecording.cons_111_tag_in}}</span>
                <el-checkbox v-model="isIn" class="check-style"></el-checkbox>
                <span class="label-padding-right-10">{{this.$root.htmlConstRecording.cons_111_tag_out}}</span>
                <el-checkbox v-model="isOut" class="check-style"></el-checkbox>
                <span class="label-padding-right-10">{{this.$root.htmlConstRecording.cons_305_internal_phone_call}}</span>
                <el-checkbox v-model="isInternalPhoneCall" class="check-style"></el-checkbox>
              </div>
            </div>
            <!-- 检索条件 - 第2行: From, 期間, 応対時間 -->
            <div class="search-condition row-2">
              <div class="flex-item search-phone-from">
                <span class="label">{{this.$root.htmlConstRecording.cons_305_phone_call_from}}</span>
                <el-input v-model="phoneCallFrom" placeholder="電話番号・内線番号または氏名を入力" class="input-phone"></el-input>
              </div>
              <div class="flex-item search-time">
                <span class="label">{{this.$root.htmlConstRecording.cons_305_phone_call_period}}</span>
                <el-date-picker
                  v-model="dateTimeFrom"
                  type="datetime"
                  value-format="yyyy/MM/dd HH:mm"
                  format="yyyy/MM/dd HH:mm"
                  placeholder="開始日時"
                  class="input-datetime">
                </el-date-picker>
                <span class="separator">～</span>
                <el-date-picker
                  v-model="dateTimeTo"
                  type="datetime"
                  value-format="yyyy/MM/dd HH:mm"
                  format="yyyy/MM/dd HH:mm"
                  placeholder="終了日時"
                  class="input-datetime">
                </el-date-picker>
              </div>
              <div class="flex-item search-spent-time">
                <span class="label">{{this.$root.htmlConstRecording.cons_305_phone_call_spent_time}}</span>
                <el-select v-model="callTimeMin" @change="handleSpentTimeFromChange" clearable placeholder="" class="input-spent-time">
                  <el-option
                    v-for="item in callTimeMinList"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                    :disabled="item.disabled"
                  />
                </el-select>
                <span class="separator">～</span>
                <el-select v-model="callTimeMax" clearable placeholder="" class="input-spent-time">
                  <el-option
                    v-for="item in callTimeMaxList"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                    :disabled="item.disabled"
                  />
                </el-select>
                <span class="unit">{{this.$root.htmlConst.cons_320_minute}}</span>
              </div>
            </div>
            <!-- 检索条件 - 第3行: 期間, 応対時間 -->
            <div class="search-condition row-3" v-if="false">
            </div>
            <!-- 检索条件 - 第4行: to, カテゴリ, アラート通知, 評価ワード, エスカレーション,  -->
            <div class="search-condition row-4">
              <div class="flex-item search-phone-to">
                <span class="label">{{this.$root.htmlConstRecording.cons_305_phone_call_to}}</span>
                <el-input v-model="phoneCallTo" placeholder="電話番号・内線番号または氏名を入力" class="input-phone"></el-input>
              </div>
              <div class="flex-item search-category">
                <span class="label">{{this.$root.htmlConst.cons_330_search_category}}</span>
                <el-select v-model="category" clearable placeholder="" class="input-spent-time">
                  <el-option
                    v-for="item in categoryArr"
                    :key="item.label"
                    :label="item.categoryTag"
                    :value="item.categoryId"
                  />
                  <!-- get category list from DB -->
                  <!-- <el-option :label="$root.htmlConst.cons_321_material_ordering" value="資材発注" />
                  <el-option :label="$root.htmlConst.cons_322_mr" value="MR相談" />
                  <el-option :label="$root.htmlConst.cons_323_product_inquiry" value="製品問い合わせ" /> -->
                </el-select>
              </div>
              <div class="flex-item search-alert">
                <span class="label">{{this.$root.htmlConst.cons_152_table_header_alert}}</span>
                <el-select v-model="alertFilter" clearable placeholder="" class="input-spent-time">
                  <el-option v-for="item in alertFilterList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </div>
              <div class="flex-item search-eval-word">
                <span class="label">{{this.$root.htmlConst.cons_152_table_header_word_count }}</span>
                <el-select v-model="evalWordFilter" clearable placeholder="" class="input-spent-time">
                  <el-option v-for="item in evalWordFilterList" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </div>
              <div class="flex-item search-type">
                <span class="label">{{this.$root.htmlConstRecording.cons_305_phone_call_type}}</span>
                <el-select v-model="voiceBotType" @change="handleSpentTimeFromChange" clearable placeholder="--区分を選択--" class="input-type">
                  <el-option
                    v-for="item in typeList"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
              </div>
            </div>
            <div class="actions">
              <el-button class="btn-action btn-action-search-conditions" @click="search()">{{this.$root.htmlConstRecording.cons_308_search_btn}}</el-button>
              <el-button class="btn-action btn-action-register-my-query">{{ this.$root.htmlConst.cons_324_register_my_query}}</el-button>
              <el-button class="btn-action btn-action-clear" @click="clear()">{{this.$root.htmlConstRecording.cons_201_btn_clear_jp}}</el-button>
              <div class="flex-grow-1"></div>
              <el-button class="btn-action btn-action-batch-download">{{this.$root.htmlConst.cons_325_bulk_download}}</el-button>
            </div>
          </div>
        </div>
        <el-row class="tool-bar tool-bar-search-results">
          <span @click="toggleShowSearchResults">
            {{ this.$root.htmlConst.cons_326_search_result}}
            <i :class="showSearchResults ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </span>
        </el-row>
        <!-- 检索结果区域 -->
        <div v-if="showSearchResults" class="wav_view_search_result">
          <el-table
            :data="this.telList"
            border
            stripe
            tooltip-effect="light"
            v-if="$root.activeName == 'voice_log'"
            class="voice-log-table"
            height="100%"
          >
            <template slot="empty">
              <p>{{ emptyText }}</p>
            </template>
            <!-- # -->
            <el-table-column label="#" width="60" :resizable="false">
              <template slot-scope="telList">
                <span v-if="telList.row.ticketNo">
                  <a class="table-content-span" target="_blank" :href="$root.redmineUrl + '/issues/' + telList.row.ticketNo">{{telList.row.ticketNo}}</a>
                </span>
                <!-- Redmine票号不存在时设定为-  -->
                <span v-else>-</span>
              </template>
            </el-table-column>
            <!-- 再生  remove [再生] column and add next action column -->
            <!-- <el-table-column :label="$root.htmlConstRecording.cons_203_table_play_jp" width="50" class="playColumn" :resizable="false">
              <template slot-scope="telList">
                <span
                  class="can-replay"
                  @click="openMask(telList.row.ticketNo, telList.row.subject, telList.row.wavPath, telList.row.dialogContent, telList.row.categoryTag,telList.row)"
                >
                  <img v-if="telList.row.wavPath" src="../../assets/img/play.png">
                  <span v-else class="can-not-replay" title="音声ファイルが削除されたため再生できません">-</span>
                </span>
              </template>
            </el-table-column> -->
            <!-- IN/OUT -->
            <el-table-column :label="$root.htmlConstRecording.cons_204_table_inout" width="70" :resizable="false">
              <template slot-scope="telList">
                <span class="table-content-span">{{telList.row.inOut}}</span>
              </template>
            </el-table-column>
            <!-- 区分（非表示） -->
            <el-table-column v-if="false" :label="$root.htmlConstRecording.cons_305_phone_call_type" width="100" :resizable="false">
              <template slot-scope="telList">
                <span class="table-content-span">{{telList.row.voiceBotType}}</span>
              </template>
            </el-table-column>
            <!-- From. -->
            <el-table-column :label="$root.htmlConstRecording.cons_305_phone_call_from">
              <!-- 電話／内線番号 -->
              <el-table-column :label="$root.htmlConstRecording.cons_307_table_phone_num" width="120" :show-overflow-tooltip="true" :resizable="false">
                <template slot-scope="telList">
                  <!-- [8899:AIVOICEBOT]时电话号码设定为- -->
                  <span v-if="telList.row.fromPhoneNum === '8899'">-</span>
                  <span v-else>
                    <!-- From的电话号码原本就是-时设定为-，防止出现a标签时显示为两个- -->
                    <span v-if="telList.row.fromPhoneNum === '-'">-</span>
                    <span v-else>
                      <!-- From的电话号码不存在时设定为- -->
                      <span v-if="!telList.row.fromPhoneNum" >-</span>
                      <span v-else>
                        <a href="#">
                          <span class="table-content-span table-content-span-display">{{telList.row.fromPhoneNum}}</span>
                        </a>
                      </span>
                    </span>
                  </span>
                </template>
              </el-table-column>
              <!-- 発信者／氏名 -->
              <el-table-column :label="$root.htmlConst.cons_316_table_header_name" width="150" :show-overflow-tooltip="true" :resizable="false">
                <template slot-scope="telList">
                  <div class="phone_call">
                    <div class="block">
                      <el-avatar v-if="!telList.row.fromUsername || !telList.row.fromLogoUrl" :src="defaultProfile"></el-avatar>
                      <el-avatar v-else :src="telList.row.fromLogoUrl"></el-avatar>
                    </div>
                    <span class="phone_call_username">{{telList.row.fromUsername || 'Guest'}}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
            <!-- エージェント -->
            <el-table-column :label="$root.htmlConst.cons_317_table_header_agent_group">
              <!-- 内線番号 -->
              <el-table-column :label="$root.htmlConst.cons_114_table_header_num" width="120" :show-overflow-tooltip="true" :resizable="false">
                <template slot-scope="telList">
                  <!-- F2F会话时，To的电话号码和用户名均设定为- -->
                  <span v-if="telList.row.voiceBotType === 'F2F会話'">-</span>
                  <span v-else>
                    <!-- [8899:AIVOICEBOT]时电话号码设定为- -->
                    <span v-if="telList.row.toPhoneNum === '8899'">-</span>
                    <span v-else>
                      <!-- To的电话号码原本就是-时设定为-，防止出现a标签时显示为两个- -->
                      <span v-if="telList.row.toPhoneNum === '-'">-</span>
                      <span v-else>
                        <!-- To的电话号码不存在时设定为- -->
                        <span v-if="!telList.row.toPhoneNum">-</span>
                        <span v-else>
                          <a href="#">
                            <span>{{telList.row.toPhoneNum}}</span>
                          </a>
                        </span>
                      </span>
                    </span>
                  </span>
                </template>
              </el-table-column>
              <!-- 氏名（着信者） -->
              <el-table-column :label="$root.htmlConst.cons_316_table_header_name" width="150" :show-overflow-tooltip="true" :resizable="false">
                <template slot-scope="telList">
                  <!-- F2F会话时，To的电话号码和用户名均设定为- -->
                  <span v-if="telList.row.voiceBotType === 'F2F会話'">-</span>
                  <span v-else>
                    <div class="phone_call">
                      <div class="block">
                        <el-avatar v-if="!telList.row.toUsername || !telList.row.toLogoUrl" :src="defaultProfile"></el-avatar>
                        <el-avatar v-else :src="telList.row.toLogoUrl"></el-avatar>
                      </div>
                      <span class="phone_call_username">{{telList.row.toUsername || 'Guest'}}</span>
                    </div>
                  </span>
                </template>
              </el-table-column>
              <!-- SV区分 -->
              <el-table-column :label="$root.htmlConst?.cons_116_table_header_sv || 'SV'" width="80" :resizable="false">
                <template>
                  <span></span>
                </template>
              </el-table-column>
              <!-- エスカレーション -->
              <el-table-column :label="$root.htmlConstRecording?.cons_106_tag_escalation || 'エスカレーション'" width="130" :resizable="false">
                <template slot-scope="telList">
                  <span>{{telList.row.escalationFlag}}</span>
                </template>
              </el-table-column>
              <!-- 内線通話 担当-->
              <el-table-column :label="$root.htmlConst.cons_327_table_header_support" width="130" :resizable="false">
                <template>
                  <span></span>
                </template>
              </el-table-column>
            </el-table-column>
            <!-- モード（エージェントの外右） -->
            <el-table-column :label="$root.htmlConst?.cons_117_table_header_mode || 'モード'" width="100" :resizable="false">
              <template>
                <span>電話</span>
              </template>
            </el-table-column>
            <!-- カテゴリ -->
            <el-table-column class-name="col-category" :render-header="renderHeader($root.htmlConst.cons_320_table_header_category)" width="340" :resizable="false">
              <template slot-scope="telList">
                <span>{{ telList.row.categoryTag || '' }}</span>
              </template>
            </el-table-column>
            <!-- タイトル -->
            <el-table-column :label="$root.htmlConstRecording.cons_307_table_subject" width="200" :resizable="false"  class-name="col-subject" >
              <template slot-scope="telList">
                <span>{{telList.row.subject}}</span>
              </template>
            </el-table-column>
            <!-- 開始 -->
            <el-table-column :label="$root.htmlConstRecording.cons_307_table_start_time" width="160" :resizable="false" class-name="call_start_end">
              <template slot-scope="telList">
                <span class="table-content-span table-content-span-display">{{formatDateTime(telList.row.callStartTime)}}</span>
              </template>
            </el-table-column>
            <!-- 終了 -->
            <el-table-column :label="$root.htmlConstRecording.cons_307_table_end_time" width="160" :resizable="false" class-name="call_start_end">
              <template slot-scope="telList">
                <span class="table-content-span table-content-span-display">{{formatDateTime(telList.row.callEndTime)}}</span>
              </template>
            </el-table-column>
            <!-- 応対時間 -->
            <el-table-column :label="$root.htmlConstRecording.cons_305_phone_call_spent_time" width="100" :resizable="false">
              <template slot-scope="telList">
                <span class="table-content-span table-content-span-display">{{telList.row.callTime}}</span>
              </template>
            </el-table-column>
            <!-- アラート通知列 -->
            <el-table-column key="alert" :label="$root.htmlConst?.cons_152_table_header_alert || 'アラート'" :resizable="false">
              <!-- 要注意 -->
              <el-table-column key="ngword" :label="$root.htmlConst.cons_311_table_header_warning" :resizable="false" width="80">
                <template slot-scope="telList">
                  <!-- show 要注意 when hover -->
                  <!-- <div v-if="telList.row.warningCount && telList.row.warningCount > 0" class="alert-warning">
                    <span>{{ telList.row.warningCount }}</span>
                  </div> -->
                  <el-tooltip placement="top" v-if="telList.row.warningCount && telList.row.warningCount > 0">
							      <div slot="content">{{ telList.row.warningWord }}</div>
                    <div class="alert-warning-word">
                      <span>{{ telList.row.warningCount }}</span>
                    </div>
						      </el-tooltip>
                  <div v-else style="color: #000">
                    <span></span>
                  </div>
                </template>
              </el-table-column>
              <!-- 緊急 -->
              <!-- 2026/03/04 remove column [緊急]-->
              <!-- <el-table-column key="urgent" :label="$root.htmlConst.cons_312_table_header_urgent" :resizable="false" width="80">
                <template slot-scope="telList">
                  <div v-if="telList.$index === 0" style="background-color: #ff0000; color: #fff; float: left; width: 100%">
                    <span>1</span>
                  </div>
                  <div v-else style="color: #000">
                    <span></span>
                  </div>
                </template>
              </el-table-column> -->
              <!-- 長時間アラート -->
              <el-table-column key="longtime" :label="$root.htmlConst?.cons_213_long_time_header || '長時間'" :resizable="false" width="80">
                <template slot-scope="telList">
                  <!-- 修正日時: 2026-02-09 - 長時間アラートをDB（通話時間）ベースで表示。longTimeFlg が true のときのみマーク表示 -->
                  <!-- <div v-if="telList.row.longTimeFlg === 'true'" class="alert-long-time">
                    <span>1</span>
                  </div> -->
                  <!-- show time when hover-->
                  <el-tooltip placement="top" v-if="telList.row.longTimeFlg === 'true'">
							      <div slot="content">{{ telList.row.callTime }}</div>
                    <div class="alert-long-time">
                      <span>1</span>
                    </div>
						      </el-tooltip>
                  <div v-else style="color: #000">
                    <span></span>
                  </div>
                </template>
              </el-table-column>
              <!-- 低評価 -->
              <!-- 20260304 remove column  [低評価]-->
              <!-- <el-table-column key="lowrating" :label="$root.htmlConst.cons_310_evaluation_header" :resizable="false" width="80">
                <template slot-scope="telList">
                  <div v-if="telList.$index === 0" style="color: #000">
                    <span></span>
                  </div>
                  <div v-else style="color: #000">
                    <span></span>
                  </div>
                </template>
              </el-table-column> -->
            </el-table-column>
            <!-- ========================================== -->
            <!-- 修正日時: 2026-03-05 -->
            <!-- 修正内容: add ポジネガ度列 -->
            <!-- ========================================== -->
            <!-- ポジネガ度列-->
            <el-table-column key="29" prop="pnDegree" :label="$root.htmlConst.cons_328_table_header_pn_degree"
                style="float: left" 
                filter-placement="bottom-end" width="90" :resizable="false">
            </el-table-column>
            <!-- 評価ワード発生回数列 -->
            <el-table-column key="wordcount" :label="$root.htmlConst?.cons_152_table_header_word_count || '評価ワード'" :resizable="false">
              <!-- Customer -->
              <el-table-column key="customer_words" :label="$root.htmlConst?.cons_124_table_header_questioner || 'お問い合わせ者'" :resizable="false">
                <!-- Wowワード -->
                <el-table-column key="customer_wow" :label="$root.htmlConst?.cons_151_table_header_wowword || 'Wowワード'" width="100" :resizable="false">
                  <template slot-scope="telList">
                    <!-- ========================================== -->
                    <!-- 修正日時: 2026-02-09 -->
                    <!-- 修正内容: 評価ワード表示 - お問い合わせ者Wowワード、0より大きい場合のみ表示 -->
                    <!-- show wow content when hover -->
                    <el-tooltip placement="top" v-if="telList.row.questionerWowCount && telList.row.questionerWowCount > 0">
                      <div slot="content">{{ telList.row.questionerWowWord }}</div>
                      <div class="alert-wow-word">
                        <span>{{ telList.row.questionerWowCount }}</span>
                      </div>
                    </el-tooltip>
                    <div v-else style="color: #000">
                      <span></span>
                    </div>
                  </template>
                </el-table-column>
                <!-- NGワード -->
                <el-table-column key="customer_ng" :label="$root.htmlConst?.cons_126_table_header_ngword || 'NGワード'" width="100" :resizable="false">
                  <template slot-scope="telList">
                    <!-- 修正日時: 2026-02-09 - 評価ワード表示 - お問い合わせ者NGワード、0より大きい場合のみ表示 -->
                    <!-- show ng content when hover -->
                    <el-tooltip placement="top" v-if="telList.row.questionerNgCount && telList.row.questionerNgCount > 0">
                      <div slot="content">{{ telList.row.questionerNgWord }}</div>
                      <div class="alert-ng-word">
                        <span>{{ telList.row.questionerNgCount }}</span>
                      </div>
                    </el-tooltip>
                    <div v-else style="color: #000">
                      <span></span>
                    </div>
                  </template>
                </el-table-column>
              </el-table-column>
              <!-- Agent -->
              <el-table-column key="agent_words" :label="$root.htmlConst?.cons_125_table_header_operator || 'オペレーター'" :resizable="false">
                <!-- Wowワード -->
                <!-- 20260304 remove column [Wowワード] -->
                <!-- <el-table-column key="agent_wow" :label="$root.htmlConst?.cons_151_table_header_wowword || 'Wowワード'" width="100" :resizable="false">
                  <template slot-scope="telList">
                    // 修正日時: 2026-02-09 - 評価ワード表示 - オペレーターWowワード、0より大きい場合のみ表示
                    <div v-if="telList.row.operatorWowCount && telList.row.operatorWowCount > 0" style="background-color: #67c23a; color: #000; float: left; width: 100%">
                      <span>{{ telList.row.operatorWowCount }}</span>
                    </div>
                    <div v-else style="color: #000">
                      <span></span>
                    </div>
                  </template>
                </el-table-column> -->
                <!-- NGマナー -->
                <el-table-column key="agent_ngmanner" :label="$root.htmlConst?.cons_150_table_header_ngmanner || 'NGマナー'" width="100" :resizable="false">
                  <template slot-scope="telList">
                    <!-- 修正日時: 2026-02-09 - 評価ワード表示 - オペレーターNGマナー、0より大きい場合のみ表示 -->
                    <!-- show ng content when hover -->
                    <el-tooltip placement="top" v-if="telList.row.operatorNgmannerCount && telList.row.operatorNgmannerCount > 0">
                      <div slot="content">{{ telList.row.operatorNgmannerWord }}</div>
                      <div class="alert-ng-manner">
                        <span>{{ telList.row.operatorNgmannerCount }}</span>
                      </div>
                    </el-tooltip>
                    <div v-else style="color: #000">
                      <span></span>
                    </div>
                  </template>
                </el-table-column>
              </el-table-column>
            </el-table-column>
            <!-- フォローアップ -->
            <el-table-column key="followUp" label="フォローアップ" :resizable="false">
              <!-- 低評価 -->
              <el-table-column key="lowrating" :label="$root.htmlConst.cons_310_evaluation_header" :resizable="false" width="80">
                <template slot-scope="telList">
                  <div v-if="telList.$index === 0" style="color: #000">
                    <span></span>
                  </div>
                  <div v-else style="color: #000">
                    <span></span>
                  </div>
                </template>
              </el-table-column>
              <!-- ACW内容 -->
              <el-table-column key="acwContent" :label="$root.htmlConst.cons_332_table_header_acw_content" :resizable="false" width="190">
                <template slot-scope="telList">
                  <div class="alert-acw-content el-tg-common" v-if="displayACWcontent(telList.row).length > 0">
                    <span class="text-wrap">{{ displayACWcontent(telList.row) }}</span>
                  </div>
                  <div v-else style="color: #000">
                    <span></span>
                  </div>
                </template>
              </el-table-column>
              <!-- ACWポップアップを開く -->
              <el-table-column :label="$root.htmlConst.cons_333_table_header_acw_dialog" :render-header="renderHeader($root.htmlConst.cons_333_table_header_acw_dialog)" width="70" class="playColumn" :resizable="false">
                <template slot-scope="telList">
                  <span
                    class="can-replay"
                    :title="telList.row.wavPath ? '' : '音声ファイルが削除されたため再生できません'"
                    @click="openMask(telList.row.ticketNo, telList.row.subject, telList.row.wavPath, telList.row.dialogContent, telList.row.categoryTag,telList.row)"
                  >
                    <i :class="['el-icon-view', 'open-acw-icon', { 'open-acw-icon-no-audio': !telList.row.wavPath }]"></i>
                  </span>
                </template>
              </el-table-column>
              <!-- 作業完了 -->
              <el-table-column key="acwFlag" :label="$root.htmlConst.cons_313_table_header_acw_completion" :render-header="renderHeader($root.htmlConst.cons_313_table_header_acw_completion)" width="70" :resizable="false">
                <template slot-scope="telList">
                  <i v-if="telList.row.isSaving" class="el-icon-loading"></i>
                  <el-checkbox v-else v-model="telList.row.completed" @change="handleCompletedChange(telList.row)"></el-checkbox>
                </template>
              </el-table-column>
            </el-table-column>
            <!-- More Action -->
            <el-table-column label="..." width="60" :resizable="false">
              <template slot-scope="telList">
                <el-dropdown trigger="click">
                  <span class="more-action">
                    <i class="el-icon-more"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <!-- 再生 -->
                    <!-- ACWポップアップを開く -->
                    <!-- <el-dropdown-item v-if="!telList.row.wavPath" disabled> -->
                      <!-- {{ $root.htmlConstRecording.cons_203_table_play_jp }} -->
                      <!-- {{ $root.htmlConst.cons_333_table_header_acw_dialog }} -->
                    <!-- </el-dropdown-item> -->
                    <!-- <el-dropdown-item v-if="telList.row.wavPath">
                      <div @click="openMask(telList.row.ticketNo, telList.row.subject, telList.row.wavPath, telList.row.dialogContent, telList.row.categoryTag,telList.row)"> -->
                        <!-- {{ $root.htmlConstRecording.cons_203_table_play_jp }} -->
                        <!-- {{ $root.htmlConst.cons_333_table_header_acw_dialog }}
                      </div>
                    </el-dropdown-item> -->
                    <!-- ダウンロード -->
                    <el-dropdown-item v-if="!telList.row.wavPath" disabled>
                      {{ $root.htmlConstRecording.cons_307_table_download }}
                    </el-dropdown-item>
                    <el-dropdown-item v-if="telList.row.wavPath" :disabled="!isSupervisor">
                      <span class="download-link" @click="downloadFile(telList.row.wavPath)">
                        {{ $root.htmlConstRecording.cons_307_table_download }}
                      </span>
                    </el-dropdown-item>
                    <!-- 削除 -->
                    <el-dropdown-item v-if="!telList.row.wavPath" disabled>
                      {{ $root.htmlConstRecording.cons_307_table_remove }}
                    </el-dropdown-item>
                    <el-dropdown-item v-if="telList.row.wavPath" :disabled="!isSupervisor">
                      <div @click="deleteWavFile(telList.row.id, telList.row.wavPath.substr(telList.row.wavPath.lastIndexOf('/') + 1))">
                        {{ $root.htmlConstRecording.cons_307_table_remove }}
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
    </div>
    <dialog-bar
      v-model="sendVal"
      :title=dialogTitle
      :issueNumber=issueNumber
      :callInfo=callInfo
      :categoryList=dialogCategoryConList
      :wowList=dialogWowConList
      :mannersList=dialogMannersConList
      :ngWordList=dialogngWordConList
      :contenttextList=dialogContentTextList
      :ngArr=wordArr
      :categoryTagArr=categoryTagArr
      :dialogAiContent=dialogAiContent
      :nextActionContent=dialogNextAction
      :dialogAcwContent=dialogAcwContent
      :alertInfo=alertInfo
    >
    </dialog-bar>
  </div>
</template>

<script>
import _ from 'lodash';
import dialogBar from './RecordingDialog.vue';
import { endsWith } from "lodash";
import moment from "moment-timezone";
import api from '@/api';
export default {
  components: { 'dialog-bar': dialogBar },
  name: 'wavView',
  data () {
    return {
      fullscreenLoading: false,
      sendVal: false,
      // 是否显示检索条件区域
      showSearchConditions: true,
      // 检索条件：テキスト検索
      textSearch: '',
      // 检索条件：ESCALATION（エスカレーターフラグ）
      isEscalation: false,
      // 检索条件：緊急フラグ
      isUrgent: false,
      // 检索条件：IN（Call Inフラグ）
      isIn: false,
      // 检索条件：OUT（Call Outフラグ）
      isOut: false,
      // 检索条件：内線
      isInternalPhoneCall: false,
      // 检索条件：From.(打电话方的电话号码或姓名)
      phoneCallFrom: '',
      // 检索条件：To.(接电话方的电话号码或姓名)
      phoneCallTo: '',
      // 检索条件：通话区分列表
      typeList: [
        '外内線通話',
        '外線通話',
        '内線通話',
        'F2F会話',
        'ボイスメール',
        '案内中脱落',
      ],
      // 检索条件：区分
      voiceBotType: '',
      // 检索条件：期间（开始时间）
      dateTimeFrom: moment().startOf('month').hours(0).minutes(0).format('YYYY/MM/DD HH:mm'),
      // 检索条件：期间（终了时间）
      dateTimeTo: moment().endOf('month').hours(23).minutes(59).format('YYYY/MM/DD HH:mm'),
      // 检索条件：应对时间选项（From分钟数）
      callTimeMinList: Array.from(Array(61), (v,k) => {return {label: `${k}`, disabled: false}}).concat([{label: '60以上', disabled: false}]),
      // 检索条件：应对时间选项（To分钟数）
      callTimeMaxList: Array.from(Array(61), (v,k) => {return {label: `${k}`, disabled: false}}).concat([{label: '60以上', disabled: false}]),
      // 检索条件：应对时间（From分钟数）
      callTimeMin: '',
      // 检索条件：应对时间（To分钟数）
      callTimeMax: '',
      // 检索条件：チケット＃
      ticketNo: '',
      // 检索条件：カテゴリ
      category: '',
      // 检索条件：アラート通知
      alertFilter: '',
      alertFilterList: [],
      // 检索条件：評価ワード
      evalWordFilter: '',
      evalWordFilterList: [],
      // 是否显示检索结果区域
      showSearchResults: true,
      // 检索结果
      telList: [],
      // 检索结果件数为0时的表示内容
      emptyText: 'データがありません',
      defaultProfile: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      dialogTitle: '',
      operator: 'オペレーター',
      questioner: 'お問い合わせ者',
      dialogCategoryConList: [],
      dialogMannersConList: [],
      dialogWowConList: [],
      dialogngWordConList: [],
      dialogContentTextList: [],
      ngArr: [],
      categoryTagArr: [],
      callInfo:{},
      issueNumber:'',
      categoryArr:[],
      dialogAiContent:'',
      dialogNextAction:'',
      // ACW content (ACW内容) shown on the popup left side; mirrors the table's ACW内容 column
      dialogAcwContent:'',
      alertInfo:{},
      wordArr:[]
    }
  },
  created() {
    // update time 2026/03/04  get VoicebotCategoryList from backend
    api.getVoicebotCategoryList().then(
      (res) =>{
        if (res && res.data && res.data.data ) {
          this.categoryArr =[];
          res.data.data.forEach(item =>{
            this.categoryArr.push(item)
          });
        }
      },
      (err) => {
        console.log(err);
      }
    );
    this.search();
  },
  computed: {
    isSupervisor() {
      return this.$root.user && this.$root.user.role === 'supervisor';
    }
  },
  methods: {
    inputKeyDown(event){
      if(event && event.keyCode == 13){
        this.search()
      }
    },  
    toggleShowSearchConditions() {
      this.showSearchConditions = !this.showSearchConditions;
    },
    toggleShowSearchResults() {
      this.showSearchResults = !this.showSearchResults;
    },
    search() {
      if (!this.checkSearchConditions()) return;
      this.fullscreenLoading = true;
      this.telList = [];
      let params = {
        textSearch: this.textSearch,
        isEscalation: this.isEscalation,
        isIn: this.isIn ? 'IN': '',
        isOut: this.isOut ? 'OUT' : '',
        isInternalPhoneCall: this.isInternalPhoneCall ? '内線' : '',
        phoneCallFrom: this.phoneCallFrom,
        phoneCallTo: this.phoneCallTo,
        voiceBotType: this.voiceBotType == '--区分を選択--' ? '' : this.voiceBotType,
        dateTimeFrom: this.dateTimeFrom,
        dateTimeTo: this.dateTimeTo,
        callTimeMin: this.callTimeMin,
        callTimeMax: this.callTimeMax,
        ticketNo: this.ticketNo,
        categoryId: this.category // add category search condition for voicebot  
      }

      var that = this;
      const maxAttempts = 3;
      const baseDelayMs = 600;
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

      (async () => {
        for (let attempt = 1; attempt <= maxAttempts; attempt++) {
          try {
            const res = await api.getRecording(params);
            if (res && res.data) {
              if (res.data.code === 0) {
                let telData = {};
                that.telList = [];
                res.data.data.forEach((data, index) => {
                  telData = {};
                  telData.id = data.id;
                  telData.ticketNo = data.ticket_no;
                  telData.inOut = data.in_out;
                  telData.voiceBotType = data.voice_bot_type;
                  telData.fromPhoneNum = data.from_phone_num;
                  telData.fromUsername = data.from_username;
                  telData.fromLogoUrl = data.from_logo_url;
                  telData.toPhoneNum = data.to_phone_num;
                  telData.toUsername = data.to_username;
                  telData.toLogoUrl = data.to_logo_url;
                  telData.subject = data.subject;
                  telData.categoryTag = data.category_tag;
                  telData.callStartTime = data.call_start_time;
                  telData.callEndTime = data.call_end_time;
                  telData.callTime = that.makeCallTime(data.call_start_time, data.call_end_time);
                  telData.wavPath = data.wav_path;
                  telData.dialogContent = data.dialog_content;
                  // ==========================================
                  // 修正日時: 2026-03-10
                  // 修正内容: add acw_content , description to list
                  telData.acwContent= data.acw_content 
                  telData.description = data.description
                  // 修正内容: add next_action (Redmine custom field id 290) for the Next Action popup area
                  telData.nextAction = data.next_action
                  // ==========================================
                  // 修正日時: 2026-02-09
                  // 修正内容: 長時間アラート - 通話分数が longTimeConfig 以上なら true（$root.longTimeConfig は /table/detail/presence で設定）
                  telData.longTimeFlg = that.isLongTimeCall(data.call_start_time, data.call_end_time) ? 'true' : 'false';
                  // ==========================================
                  // 修正日時: 2026-02-09
                  // 修正内容: 評価ワード発生回数 - APIレスポンス（snake_case）をcamelCaseにマッピング、文字列を数値に変換
                  telData.questionerWowCount = Number(data.questioner_wow_count) || 0;
                  telData.questionerWowWord = data.questioner_wow_word
                  telData.questionerNgCount = Number(data.questioner_ng_count) || 0;
                  telData.questionerNgWord = data.questioner_ng_word
                  telData.operatorWowCount = Number(data.operator_wow_count) || 0;
                  telData.operatorWowWord = data.operator_wow_word
                  telData.operatorNgCount = Number(data.operator_ng_count) || 0;
                  telData.operatorNgWord = data.operator_ng_word
                  telData.operatorNgmannerCount = Number(data.operator_ngmanner_count) || 0;
                  telData.operatorNgmannerWord = data.operator_ngmanner_word
                  // ==========================================
                  // 修正日時: 2026-03-11
                  // 修正内容: get【要注意】 from api
                  telData.warningCount = Number(data.warning_count) || 0;
                  telData.warningWord = data.warning_word

                  // 作業完了ステータスの初期値（DBから取得して更新する）
                  telData.completed = (data.acw_completed && data.acw_completed =='1')? true:false;
                  telData.isSaving = false;
                  telData.escalationFlag = data.escalation_flag? 'Yes':'';
                  that.telList.push(telData);

                  // ACW COMPLETEDステータスをDBから取得
                  // if (data.ticket_no) {
                  //   (function(td) {
                  //     api.getAcwCompleted(data.ticket_no).then((acwRes) => {
                  //       if (acwRes.data && acwRes.data.code === 0 && acwRes.data.data) {
                  //         that.$set(td, 'completed', acwRes.data.data.value === '1');
                  //       }
                  //     }).catch(() => {});
                  //   })(telData);
                  // }
                });
                that.fullscreenLoading = false;
                return;
              }
              that.fullscreenLoading = false;
              that.$message.error(res.data.msg || 'SystemError');
              return;
            }
            if (attempt < maxAttempts) {
              await delay(baseDelayMs * Math.pow(2, attempt - 1));
              continue;
            }
            that.fullscreenLoading = false;
            that.$message.error('SystemError');
            return;
          } catch (err) {
            if (attempt < maxAttempts) {
              await delay(baseDelayMs * Math.pow(2, attempt - 1));
              continue;
            }
            that.fullscreenLoading = false;
            const msg = (err && (err.msg || err.message)) || 'SystemError';
            that.$message.error(msg);
          }
        }
      })();
    },
    checkSearchConditions() {
      return true;
    },
    resetSearchConditions() {
      this.textSearch = '';
      this.isEscalation = false;
      this.isIn = false;
      this.isOut = false;
      this.isInternalPhoneCall = false;
      this.phoneCallFrom = '';
      this.phoneCallTo = '';
      this.voiceBotType = '--区分を選択--';
      this.dateTimeFrom = moment().startOf('month').hours(9).minutes(0).format('YYYY/MM/DD HH:mm');
      this.dateTimeTo = moment().endOf('month').hours(18).minutes(0).format('YYYY/MM/DD HH:mm');
      this.callTimeMin = '';
      this.callTimeMax = '';
      this.ticketNo = '';
    },
    clear() {
      this.textSearch = '';
      this.isEscalation = false;
      this.isUrgent = false;
      this.isIn = false;
      this.isOut = false;
      this.isInternalPhoneCall = false;
      this.phoneCallFrom = '';
      this.phoneCallTo = '';
      this.voiceBotType = '--区分を選択--';
      this.dateTimeFrom = '';
      this.dateTimeTo = '';
      this.callTimeMin = '';
      this.callTimeMax = '';
      this.ticketNo = '';
      this.category = '';
      this.alertFilter = '';
      this.evalWordFilter = '';
      this.search();
    },
    handleVoiceBotTypeSelection(voiceBotType) {
      this.voiceBotType = voiceBotType;
    },
    async openMask(ticketNo, subject, wavPath, content, categoryTag, oneRecord){
      this.fullscreenLoading = true;
      this.dialogTitle =  '';
      this.ngArr = [];
      this.wordArr=[]
      this.categoryTagArr = [];
      this.dialogCategoryConList = [];
      this.dialogMannersConList = [];
      this.dialogWowConList = [];
      this.dialogngWordConList = [];
      this.dialogContentTextList = [];
      this.callInfo={}
      this.issueNumber =''
      this.dialogAiContent = oneRecord.description || ''
      // Next Action（次のアクション）: read-only, from Redmine custom field id 290 (next_action)
      this.dialogNextAction = oneRecord.nextAction || ''
      // ACW content (ACW内容): reuse displayACWcontent so empty / '自己解決' are blanked like the table column
      this.dialogAcwContent = this.displayACWcontent(oneRecord)
      // 2026-03-12 pass alter info ngCount longtimeFlg , waringCount[要注意] to pop window 
      this.alertInfo = {
        ngCount: Number(oneRecord.questionerNgCount || 0) + Number(oneRecord.operatorNgCount || 0),
        longTimeFlg: oneRecord.longTimeFlg,
        warningCount: Number(oneRecord.warningCount || 0)
      }
      if (ticketNo) {
        var that = this;
        // ==========================================
        // 修正日時: 2026-02-09
        // 修正内容: 録音再生 - getNgWordの成否に関係なくDBから全文取得(233/12)、--------でブロック分割しセパレータ行を行にしない
        // ==========================================
        // ==========================================
        // 修正日時: 2026-02-27
        // 修正内容: Wait for api.getDialogContent to complete ,then execute next code 
        // ========================================== 
        try { 
          const res = await api.getDialogContent(ticketNo); 
          if (res.data && res.data.code === 0 && res.data.data && res.data.data.value != null && res.data.data.value !== '') {
            content = res.data.data.value 
          }
        } catch (e) {}
        // api.getDialogContent(ticketNo).then((res) => {
        //   if (res.data && res.data.code === 0 && res.data.data && res.data.data.value != null && res.data.data.value !== '') {
        //     var raw = String(res.data.data.value);
        //     var blocks = raw.split(/\r?\n--------\r?\n/);
        //     that.dialogContentTextList = blocks.map(function (text) { return { text: text.trim() }; }).filter(function (item) { return item.text !== ''; });
        //   }
        // }).catch(function () {});
        //=============================================
        // update time : 2026-03-13 
        // update content : get [要注意] /NG/WOW/NG manner  word array from wav list 
        this.wordArr = this.generateWordArr(oneRecord)  
        // convert time to JST time 
        content =this.$utils.convertTimesToJST(content)  
        // Highlight the waring/ng/ngmanner/wow word 
        let hightLightText =this.highlightFromRawText(content)
        // format dialog content 
        that.dialogContentTextList = hightLightText.map(text => {return{text: text.trim()}}).filter(item =>item.text !== '');
        // set categoryTagArr 
        this.categoryTagArr.push({type:"",name:categoryTag})
        // format dialog content 
        // that.dialogContentTextList = content.split(/\r?\n--------\r?\n/).map(text => {return{text: text.trim()}}).filter(item =>item.text !== '');
        
        this.issueNumber = ticketNo.toString();
        this.setCallInfo(oneRecord)
        if (subject) {
          that.dialogTitle = that.dialogTitle + "　" + subject;
        }
        that.wavPath = wavPath;
        that.setAudioSource(wavPath);
        that.sendVal = true;
        that.fullscreenLoading = false;
        // remove the Highlight Warnig/ng/wow word below , and add new logic abrove
        // api.getNgWord(ticketNo).then((res) => {
        //   if (res.data.code != 0) {
        //     console.error('error occurred during retrieving ng words.');
        //     // getNgWord失敗時もダイアログは開く（最終処理へ進む）
        //   } else {
        //   var listKey = 0;

        //   var categoryContent = content;

        //   if (categoryTag && categoryTag != '') {
        //     var categoryTagList = categoryTag.split(') ');
        //     categoryTagList.forEach((data) => {
        //       if (data && data != '') {
        //         var lastIndex = data.lastIndexOf('(');
        //         var changeStr = data.substring(0, lastIndex);
        //         var categoryTagObject = {};
        //         if (endsWith(data, ')')) {
        //           categoryTagObject['name'] = data;
        //         } else {
        //           categoryTagObject['name'] = data + ')';
        //         }
        //         categoryTagObject['type'] = '';
        //         that.categoryTagArr.push(categoryTagObject);
        //         if (categoryContent) {
        //           var findText = categoryContent.split(changeStr);
        //           categoryContent = findText.join('<span class="categoryType">' + changeStr + '</span>');
        //         }
        //       }
        //     });
        //   }

        //   if (categoryContent && categoryContent != '') {
        //     var tempList = categoryContent.split('\r\n');
        //     var dialogContent;
        //     tempList.forEach((data) => {
        //       dialogContent = {};
        //       dialogContent.text = data;
        //       that.dialogCategoryConList.push(dialogContent);
        //     });
        //   }

        //   if (content && content != '') {
        //     var contentList = [];
        //     let tempList = content.split('\n--------\n');
        //     let dialogContent;
        //     tempList.forEach((data) => {
        //       dialogContent = {};
        //       dialogContent.text = data;
        //       contentList.push(dialogContent);
        //     });

        //     var operatorNgMannerList = res.data.data.operatorNgManner;
        //     var operatorNgWordList = res.data.data.operatorNgWord;
        //     var questionerNgWordList = res.data.data.questionerNgWord;
        //     var questionerWowWordList = res.data.data.questionerWowWord;
        //     var operatorWowWordList = res.data.data.operatorWowWord;

        //     // if (operatorNgWordList && operatorNgWordList.length != 0) {

        //     //   that.dialogngWordConList = contentList;

        //     //   operatorNgWordList.forEach((word) => {
        //     //     var count = 0;
        //     //     that.dialogngWordConList.forEach((row)  => {
        //     //       var rowText = row.text;
        //     //       var dialog = rowText.split(':');
        //     //       var dialog_left = dialog[0];
        //     //       if (dialog_left.indexOf(that.operator) > -1) {
        //     //       // if (rowText.startsWith(that.operator)) {
        //     //         var findText = rowText.split(word.ngword);
        //     //         if (findText.length > 0) {
        //     //           count = count + findText.length - 1;
        //     //         }
        //     //         row.text = findText.join('<span class="ngwordOType">' + word.ngword + '</span>');
        //     //       }
        //     //     });
        //     //     var ngObject = {};
        //     //     ngObject['key'] = listKey++;
        //     //     ngObject['name'] = word.ngword + '(' + count + ')';
        //     //     ngObject['type'] = 'ngwordOType';
        //     //     that.ngArr.push(ngObject);
        //     //   });

        //     //   if(questionerNgWordList.length == 0){
        //     //     let arr = that.dialogngWordConList.map((i)=>{
        //     //       return i.text;
        //     //     })
        //     //     let _a = [{
        //     //       text:arr.join('\n--------\n')
        //     //     }]
        //     //     that.dialogngWordConList = _a;
        //     //   }
              
        //     // }

        //     if ((questionerNgWordList && questionerNgWordList.length != 0) || (operatorNgWordList && operatorNgWordList.length != 0)) {
        //       let ngWordList = [];
        //       if(questionerNgWordList && questionerNgWordList.length != 0){
        //         ngWordList = ngWordList.concat(questionerNgWordList);
        //       }
        //       if(operatorNgWordList && operatorNgWordList.length != 0){
        //         ngWordList = ngWordList.concat(operatorNgWordList);
        //       }

        //       if (that.dialogngWordConList.length == 0) {
        //         that.dialogngWordConList = contentList;
        //       }

        //       ngWordList.forEach((word) => {
        //         var count = 0;
        //         that.dialogngWordConList.forEach((row)  => {
        //           var rowText = row.text;
        //           // var dialog = rowText.split(':');
        //           // var dialog_left = dialog[0];
        //           // if (dialog_left.indexOf(that.questioner) > -1) {
        //           // if (rowText.startsWith(that.questioner)) {
        //             var findText = rowText.split(word.ngword);
        //             if (findText.length > 0) {
        //               count = count + findText.length - 1;
        //             }
        //             row.text = findText.join('<span class="ngwordQType">' + word.ngword + '</span>');
        //           // }
        //         });
        //         var ngObject = {};
        //         ngObject['key'] = listKey++;
        //         ngObject['name'] = word.ngword + '(' + count + ')';
        //         ngObject['type'] = 'ngwordQType';
        //         that.ngArr.push(ngObject);
        //       });

             
        //       let arr = that.dialogngWordConList.map((i)=>{
        //         return i.text;
        //       })
        //       let _a = [{
        //         text:arr.join('\n--------\n')
        //       }]
        //       that.dialogngWordConList = _a;
        //     }

        //     if (operatorNgMannerList && operatorNgMannerList.length != 0) {

        //       that.dialogMannersConList = contentList;

        //       operatorNgMannerList.forEach((manner) => {
        //         var count = 0;
        //         that.dialogMannersConList.forEach((row)  => {
        //           var rowText = row.text;
        //           var dialog = rowText.split(':');
        //           var dialog_left = dialog[0];
        //           if (dialog_left.indexOf(that.operator) > -1) {
        //             var findText = rowText.split(manner.ngword);
        //             if (findText.length > 0) {
        //               count = count + findText.length - 1;
        //             }
        //             row.text = findText.join('<span class="ngMannerType">' + manner.ngword + '</span>');
        //           }
        //         });
        //         var ngObject = {};
        //         ngObject['key'] = listKey++;
        //         ngObject['name'] = manner.ngword + '(' + count + ')';
        //         ngObject['type'] = 'ngMannerType';
        //         that.ngArr.push(ngObject);
        //       });
              
        //       let arr = that.dialogMannersConList.map((i)=>{
        //         return i.text;
        //       })
        //       let _a = [{
        //         text:arr.join('\n--------\n')
        //       }]
        //       that.dialogMannersConList = _a;
        //     }

        //     // if (questionerWowWordList && questionerWowWordList.length != 0) {

        //     //   that.dialogWowConList = contentList;

        //     //   questionerWowWordList.forEach((wow) => {
        //     //     var count = 0;
        //     //     that.dialogWowConList.forEach((row)  => {
        //     //       var rowText = row.text;
        //     //       var dialog = rowText.split(':');
        //     //       var dialog_left = dialog[0];
        //     //       if (dialog_left.indexOf(that.questioner) > -1) {
        //     //       // if (rowText.startsWith(that.questioner)) {
        //     //         var findText = rowText.split(wow.wowword);
        //     //         if (findText.length > 0) {
        //     //           count = count + findText.length - 1;
        //     //         }
        //     //         row.text = findText.join('<span class="ngWowType">' + wow.wowword + '</span>');
        //     //       }
        //     //     });
        //     //     var ngObject = {};
        //     //     ngObject['key'] = listKey++;
        //     //     ngObject['name'] = wow.wowword + '(' + count + ')';
        //     //     ngObject['type'] = 'ngWowType';
        //     //     that.ngArr.push(ngObject);
        //     //   });

        //     //   if(operatorWowWordList.length == 0){
        //     //     let arr = that.dialogWowConList.map((i)=>{
        //     //       return i.text;
        //     //     })
        //     //     let _a = [{
        //     //       text:arr.join('\n--------\n')
        //     //     }]
        //     //     that.dialogWowConList = _a;
        //     //   }
              
        //     // }

            
        //     if ((operatorWowWordList && operatorWowWordList.length != 0) || (questionerWowWordList && questionerWowWordList.length != 0)) {
        //       let wowWordList = [];
        //       if(operatorWowWordList && operatorWowWordList.length != 0){
        //         wowWordList = wowWordList.concat(questionerNgWordList);
        //       }
        //       if(questionerWowWordList && questionerWowWordList.length != 0){
        //         wowWordList = wowWordList.concat(questionerWowWordList);
        //       }

        //       if (that.dialogWowConList.length == 0) {
        //         that.dialogWowConList = contentList;
        //       }

        //       wowWordList.forEach((wow) => {
        //         var count = 0;
        //         that.dialogWowConList.forEach((row)  => {
        //           var rowText = row.text;
        //           // var dialog = rowText.split(':');
        //           // var dialog_left = dialog[0];
        //           // if (dialog_left.indexOf(that.operator) > -1) {
        //           // if (rowText.startsWith(that.operator)) {
        //             var findText = rowText.split(wow.wowword);
        //             if (findText.length > 0) {
        //               count = count + findText.length - 1;
        //             }
        //             row.text = findText.join('<span class="ngWowType">' + wow.wowword + '</span>');
        //           // }
        //         });
        //         var ngObject = {};
        //         ngObject['key'] = listKey++;
        //         ngObject['name'] = wow.wowword + '(' + count + ')';
        //         ngObject['type'] = 'ngWowType';
        //         that.ngArr.push(ngObject);
        //       });
             
        //       let arr = that.dialogWowConList.map((i)=>{
        //         return i.text;
        //       })
        //       let _a = [{
        //         text:arr.join('\n--------\n')
        //       }]
        //       that.dialogWowConList = _a;

        //     }

        //     var contenttext = content;
        //     if (contenttext && contenttext != '') {
        //       let tempList = contenttext.split('\r\n');
        //       let dialogContent;
        //       tempList.forEach((data) => {
        //         dialogContent = {};
        //         dialogContent.text = data;
        //         that.dialogContentTextList.push(dialogContent);
        //       });
        //     }
        //   }

        //   }
        //   // if (ticketNo) {
        //   //   that.dialogTitle = that.dialogTitle + ticketNo;
        //   // }
        //   this.issueNumber = ticketNo.toString();
        //   this.setCallInfo(oneRecord)
        //   if (subject) {
        //     that.dialogTitle = that.dialogTitle + "　" + subject;
        //   }
        //   that.wavPath = wavPath;
        //   if (document.getElementById('audioPlayer')) {
        //     document.getElementById('audioPlayer').src = wavPath;
        //   }
        //   that.sendVal = true;
        //   that.fullscreenLoading = false;
        // }, (err) => {
        //   that.fullscreenLoading = false;
        //   console.log('search',err);
        // });
      } else {

        var categoryContent = content;
        if (categoryTag && categoryTag != '') {
          var categoryTagList = categoryTag.split(') ');
          categoryTagList.forEach((data) => {
            if (data && data != '') {
              var lastIndex = data.lastIndexOf('(');
              var changeStr = data.substring(0, lastIndex);
              var categoryTagObject = {};
              if (endsWith(data, ')')) {
                categoryTagObject['name'] = data;
              } else {
                categoryTagObject['name'] = data + ')';
              }
              categoryTagObject['type'] = '';
              this.categoryTagArr.push(categoryTagObject);
              if (categoryContent) {
                var findText = categoryContent.split(changeStr);
                categoryContent = findText.join('<span class="categoryType">' + changeStr + '</span>');
              }
            }
          });
        }

        if (categoryContent && categoryContent != '') {
          var tempList = categoryContent.split('\r\n');
          var dialogContent;
          tempList.forEach((data) => {
            dialogContent = {};
            dialogContent.text = data;
            this.dialogCategoryConList.push(dialogContent);
          });
        }

        var contenttext = content;
        if (contenttext && contenttext != '') {
          let tempList = contenttext.split('\r\n');
          let dialogContent;
          tempList.forEach((data) => {
            dialogContent = {};
            dialogContent.text = data;
            this.dialogContentTextList.push(dialogContent);
          });
        }
		
        // if (ticketNo) {
        //   this.dialogTitle = this.dialogTitle + ticketNo;
        // }
		this.setCallInfo(oneRecord)
        if (subject) {
          this.dialogTitle = this.dialogTitle + "　" + subject;
        }
        this.wavPath = wavPath;
        this.setAudioSource(wavPath);
        this.sendVal = true;
        this.fullscreenLoading = false;
      }
    },
    deleteWavFile(id, wavPath) {
      if (!this.isSupervisor) return;

      this.$confirm('本当に削除しますか？', '', {
        cancelButtonText: 'キャンセル',
        confirmButtonText: 'OK',
        // type: 'warning',
        customClass: 'recording-delete-confirm'
      }).then(() => {
        api.deleteWavFile(id, wavPath).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 0) {
                // 弹出操作成功的消息条
                this.$message({
                  message: '音声ファイルが削除されました',
                  type: 'success'
                });
                // 更新前台保持的查询结果而不是刷新页面
                this.telList.forEach(e => {
                  if (e.id === id) {
                    e.wavPath = '';
                  }
                })
              }
            }
          } else {
            this.$message({
                  message: '音声ファイルの削除が失敗しました',
                  type: 'error'
                });
          }
        })
      }).catch(() => {});
    },
    downloadFile(wavPath) {
      if (!this.isSupervisor) return;
      this.fullscreenLoading = true;
      api
        .getDownload(wavPath)
        .then((res) => {
          let fileName = wavPath.substr(wavPath.lastIndexOf("/") + 1);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style.display = "none";
          let url = window.URL.createObjectURL(new Blob([res.data]));
          a.href = url;
          a.download = fileName;
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.fullscreenLoading = false;
        });
    },
    formatDateTime(dateTime) {
      return moment(dateTime).format('YYYY/MM/DD HH:mm:ss')
    },
    setAudioSource(wavPath) {
      const audioPlayer = document.getElementById('audioPlayer');
      if (!audioPlayer) return;
      // Empty wav URLs should still open the ACW dialog, but must not keep or play a previous recording.
      audioPlayer.pause();
      audioPlayer.src = wavPath || '';
      audioPlayer.load();
    },
    handleSpentTimeFromChange(selected) {
      let from = selected === '60以上' ? 61: (selected === '' ? -1 : parseInt(selected));
      let to = this.callTimeMax === '60以上' ? 61: (this.callTimeMax === '' ? -1 : parseInt(this.callTimeMax));
      this.callTimeMaxList = this.callTimeMaxList.map((v, i) => {
        return {...v, disabled: i < from}
      })
      if (from > to) {
        this.callTimeMax = '';
      }
    },
    makeCallTime(callStartTime, callEndTime) {
      const duration = moment.duration(moment(callEndTime, 'YYYY-MM-DD HH:mm:ss').diff(moment(callStartTime, 'YYYY-MM-DD HH:mm:ss')));
      let minutes = `${parseInt(duration.asMinutes())}`.padStart(2, 0);
      let seconds = `${parseInt(duration.seconds())}`.padStart(2, 0);
      return `${minutes}:${seconds}`;
    },
    // ==========================================
    // 修正日時: 2026-02-09
    // 修正内容: 長時間アラート判定 - 通話分数が $root.longTimeConfig 以上なら true。設定が0の場合は false。
    isLongTimeCall(callStartTime, callEndTime) {
      if (!callStartTime || !callEndTime) return false;
      const config = Number(this.$root.longTimeConfig) || 0;
      if (config <= 0) return false;
      const start = moment(callStartTime, ['YYYY/MM/DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss']);
      const end = moment(callEndTime, ['YYYY/MM/DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss']);
      if (!start.isValid() || !end.isValid()) return false;
      const minutes = moment.duration(end.diff(start)).asMinutes();
      return minutes >= config;
    },
    // ==========================================
    // 修正日時: 2026-02-09
    // 修正内容: 録音再生 - callTimeをcallInfoに追加（音声ファイル取得できない時に再生時間表示用）
    setCallInfo(oneRecord){
		this.callInfo = {
			fromUsername: oneRecord.fromUsername || 'Guest',
          	fromLogoUrl: !oneRecord.fromUsername || !oneRecord.fromLogoUrl ? this.defaultProfile : oneRecord.fromLogoUrl,
          	fromPhoneNum: oneRecord.fromPhoneNum === '8899'? '-' :( oneRecord.fromPhoneNum ? oneRecord.fromPhoneNum :'-'),
          	toUsername: oneRecord.voiceBotType === 'F2F会話' ? '-' : (oneRecord.toUsername || 'Guest'),
          	toLogoUrl: oneRecord.voiceBotType === 'F2F会話' ? '-' : (!oneRecord.toUsername || !oneRecord.toLogoUrl ? this.defaultProfile : oneRecord.toLogoUrl),
          	toPhoneNum: oneRecord.voiceBotType === 'F2F会話' ? '-': (oneRecord.toPhoneNum === '8899'? '-' :( oneRecord.toPhoneNum ? oneRecord.toPhoneNum :'-')),
          	callType: oneRecord.inOut,
			callStartTime:oneRecord.callStartTime,
			callEndTime:oneRecord.callEndTime,
			callTime: oneRecord.callTime || '',
        }
    },
    handleCompletedChange(row) {
      // 作業完了チェックボックスの変更を処理
      // ACW COMPLETEDステータスをデータベースに保存
      const issueId = row.ticketNo;
      const value = row.completed ? '1' : '0';
      if (!issueId) {
        console.warn('作業完了: ticketNoが存在しないため保存できません');
        return;
      }
      // 保存中状態を設定（loading iconを表示）
      this.$set(row, 'isSaving', true);

      api.updateAcwCompleted(issueId, value).then((res) => {
        if (res.data && res.data.code === 0) {
          console.log('作業完了状態が保存されました:', issueId, value);
        } else {
          console.error('作業完了状態の保存に失敗しました:', res.data);
          // 保存失敗時にチェックボックスを元に戻す
          row.completed = !row.completed;
          this.$message.error('作業完了状態の保存に失敗しました');
        }
      }).catch((err) => {
        console.error('作業完了状態の保存中にエラーが発生しました:', err);
        // エラー時にチェックボックスを元に戻す
        row.completed = !row.completed;
        this.$message.error('作業完了状態の保存に失敗しました');
      }).finally(() => {
        // 保存完了、isSavingを解除（checkboxを再表示）
        this.$set(row, 'isSaving', false);
      });
    },
    // ==========================================
    // 修正日時: 2026-02-09
    // 修正内容: 評価ワードツールチップ用 - ticketNoから評価ワード詳細を取得（キャッシュあり）
    getWordDetailsText(row, wordType) {
      if (!row.ticketNo) return '';
      const ticketNo = row.ticketNo.toString();
      
      // キャッシュにない、またはnullの場合は空文字を返す
      if (!this.wordDetailsCache[ticketNo] || this.wordDetailsCache[ticketNo] === null) return '';
      
      const cache = this.wordDetailsCache[ticketNo];
      const parts = [];
      
      switch(wordType) {
        case 'questionerWow':
          if (cache.questionerWowWord && cache.questionerWowWord.length > 0) {
            parts.push(...cache.questionerWowWord.map(w => w.wowWord));
          }
          break;
        case 'questionerNg':
          if (cache.questionerNgWord && cache.questionerNgWord.length > 0) {
            parts.push(...cache.questionerNgWord.map(w => w.ngWord));
          }
          break;
        case 'operatorWow':
          if (cache.operatorWowWord && cache.operatorWowWord.length > 0) {
            parts.push(...cache.operatorWowWord.map(w => w.wowWord));
          }
          break;
        case 'operatorNg':
          if (cache.operatorNgWord && cache.operatorNgWord.length > 0) {
            parts.push(...cache.operatorNgWord.map(w => w.ngWord));
          }
          break;
        case 'operatorNgmanner':
          if (cache.operatorNgManner && cache.operatorNgManner.length > 0) {
            parts.push(...cache.operatorNgManner.map(w => w.ngWord));
          }
          break;
      }
      
      return parts.length > 0 ? parts.join(', ') : '';
    },
    // ==========================================
    // 修正日時: 2026-02-09
    // 修正内容: 評価ワードツールチップ用 - ticketNoで評価ワード詳細を非同期取得してキャッシュ（Vue.setでリアクティビティ確保）
    loadWordDetails(ticketNo) {
      if (!ticketNo) return;
      const ticketNoStr = ticketNo.toString();
      
      // 既にキャッシュにある場合（null以外）はスキップ
      if (this.wordDetailsCache[ticketNoStr] && this.wordDetailsCache[ticketNoStr] !== null) return;
      
      // ローディング中フラグを設定（重複リクエスト防止）
      this.$set(this.wordDetailsCache, ticketNoStr, null);
      
      const that = this;
      console.log('[loadWordDetails] Loading word details for ticketNo:', ticketNoStr);
      api.getNgWord(ticketNo).then((res) => {
        console.log('[loadWordDetails] API response for ticketNo:', ticketNoStr, res.data);
        if (res.data && res.data.code === 0 && res.data.data) {
          // Vue.setでリアクティビティを確保
          that.$set(that.wordDetailsCache, ticketNoStr, res.data.data);
          console.log('[loadWordDetails] Cached word details:', res.data.data);
          // 強制的に再レンダリングをトリガー
          that.$forceUpdate();
        } else {
          console.log('[loadWordDetails] No data for ticketNo:', ticketNoStr);
          // データがない場合は空オブジェクトをキャッシュ
          that.$set(that.wordDetailsCache, ticketNoStr, {});
        }
      }).catch(function (err) {
        console.error('[loadWordDetails] Error loading word details for ticketNo:', ticketNoStr, err);
        // エラー時は空オブジェクトをキャッシュして再試行を防ぐ
        that.$set(that.wordDetailsCache, ticketNoStr, {});
      });
    },
    // ==========================================
    // 修正日時: 2026-03-13
    // 修正内容: get 【要注意】/NG/WOW  WORD Array from wav list  
    generateWordArr(record){
      //merge the ng word 
      // const ngWordAll = [record.questionerNgWord, record.operatorNgWord].filter(str => str && str.trim() !== "").join(",");
      //merge the wow word 
      // const wowWordAll = [record.questionerWowWord, record.operatorWowWord].filter(str => str && str.trim() !== "").join(",");
      // const ngWordObject = this.parseWords('ngwordQType',ngWordAll)
      // const wowWordObject = this.parseWords('ngWowType',wowWordAll)
      const warningWordObject = this.parseWords('warningWordType',record.warningWord)
      const ngWordObject = this.parseWords('ngwordQType',record.questionerNgWord)
      const wowWordObject = this.parseWords('ngWowType',record.questionerWowWord)
      const ngMannerObject = this.parseWords('ngMannerType',record.operatorNgmannerWord) 
      return [...warningWordObject,...ngWordObject,...wowWordObject,...ngMannerObject]
    },
    parseWords(type, wordString) {
      if(!wordString) {
        return []
      }
      const words = wordString.split(",") .map(w => w.trim()).filter(w => w !== "");
      // count times for each word
      const map = {};
      words.forEach(w => {
        map[w] = (map[w] || 0) + 1;
      });
      // return object
      return Object.keys(map).map(word => ({
        type,
        word,
        count: map[word],
        name: word + '(' + map[word] + ')'
      }));  
    },
    renderHeader(headerText) {
      // Return a reusable renderer that centers and wraps long table header labels.
      return (h) => h('div', {
        style: {
          lineHeight: '20px',
          textAlign: 'center',
          width: '100%',
          whiteSpace: 'normal',
        },
        domProps: {
          innerHTML: headerText
        }
      })
    },
    highlightFromRawText(rawText) {
      const lines = rawText.split(/\r?\n--------\r?\n/);
      return lines.map(line => {
        let trimmedLine = line.trim();
        // check role for the line 
        const isQuestioner = trimmedLine.includes(this.questioner);
        if(this.wordArr.length == 0)
        return trimmedLine
        this.wordArr.forEach((item =>{
          // replace warning word with warning word highlight style 
          if(item.type === 'warningWordType'){
            trimmedLine = trimmedLine.replace(new RegExp(item.word, 'g'), `<span class="warningWordType">${item.word}</span>`);
          }
          // replace ng word with ng word highlight style 
          if(isQuestioner && item.type === 'ngwordQType') {
            trimmedLine = trimmedLine.replace(new RegExp(item.word, 'g'), `<span class="ngwordQType">${item.word}</span>`);
          }
          //replace wow word with wow word highlight style  
          if(isQuestioner &&item.type === 'ngWowType') {
            trimmedLine = trimmedLine.replace(new RegExp(item.word, 'g'), `<span class="ngWowType">${item.word}</span>`);
          }
          //replace ng manner word with ng manner word hightlight style 
          if (!isQuestioner &&item.type === 'ngMannerType') {
            trimmedLine = trimmedLine.replace(new RegExp(item.word, 'g'), `<span class="ngMannerType">${item.word}</span>`);
          }
        }))
        return trimmedLine;
      });
    },
    displayACWcontent(record) {
      if(!record || !record.acwContent || record.acwContent.trim() === '' || record.acwContent.trim() === '自己解決') {
        return '';
      }
      return record.acwContent;
    }

  }
}
</script>

<style lang="scss" scoped>
.search-conditions-container {
  padding: 10px 50px;
  :deep(.el-select) {
    margin-left: 0;
  }
}
.search-conditions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.search-condition {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 24px;
  row-gap: 12px;
  &.row-1 {
    column-gap: 30px;
  }
  &.row-2 {
    column-gap: 24px;
  }
  &.row-3 {
    column-gap: 20px;
  }
  &.row-4 {
    column-gap: 24px;
  }
}
.flex-item {
  display: flex;
  align-items: center;
  gap: 8px;
  .label {
    min-width: 70px;
    white-space: nowrap;
  }
}
// チケット#
.search-ticket .input-ticket {
  width: 140px;
}
// テキスト検索
.search-keyword .input-text-search {
  width: 200px;
  :deep(.el-input__inner) {
    padding-right: 30px;
  }
  :deep(.el-input__icon) {
    vertical-align: -0.15em;
  }
}
// From/To
.search-phone-from .input-phone,
.search-phone-to .input-phone {
  width: 255px;
}
// 区分
.search-type {
  .label {
    min-width: 45px;
    width: 45px;
  }
  .input-type {
    width: 130px;
  }
}
// 期間
.search-time {
  .input-datetime {
    width: 180px;
  }
  .separator {
    margin: 0 4px;
  }
  :deep(.el-input__icon) {
    vertical-align: -0.15em;
  }
  :deep(.el-input__inner) {
    /* padding-right: 4px; */
    padding-left: 30px !important;
  }
}
// 応対時間
.search-spent-time {
  .input-spent-time {
    width: 90px;
  }
  .separator {
    margin: 0 4px;
  }
  .unit {
    margin-left: 4px;
  }
}
// カテゴリ（プルダウン幅を広げる）
.search-category .input-spent-time {
  width: 140px;
}
// アラート通知・評価ワード（応対時間と統一）
.search-alert,
.search-eval-word {
  .input-spent-time {
    width: 90px;
  }
}
// 緊急（ラベル幅を縮める）
.search-urgent {
  .label {
    min-width: 40px;
    width: 40px;
  }
}
// Label和右侧的复选框等表单元素之间保持10px的距离
.label-padding-right-10 {
  padding-right: 10px;
}
// Label和左侧的下拉框等表单元素之间保持5px的距离
.label-padding-left-5 {
  padding-left: 5px;
}
// IN OUT 内线三个复选选项之间保持20px的距离
.in-out-internal-phone-call {
  .el-checkbox {
    margin-right: 20px;
  }
}
.tool-bar {
  padding: 10px 0;
  text-align: center;
  & span {
    cursor: pointer;
  }
}
.el-row {
  // margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.actions {
  display: flex;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: 10px;
  .el-button {
    margin-left: 0;
  }
  .flex-grow-1 {
    flex-grow: 1;
  }
}
.btn-action {
  width: 120px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 5px;
  background-color: #2f70c1;
  color: #fff;
  height: 35px;
}
.btn-action-clear {
  background-color: #fff;
  color: #2f70c1;
}
.btn-action-clear:hover {
  color: #2f70c1;
}
.btn-action-clear:focus {
  color: #2f70c1;
}
.voice-log-table {
  :deep(.el-table__header .el-table__cell) {
    background-color: #49b1f3;
  }
  // ヘッダーの縦の余白を減らす
  :deep(.el-table__header-wrapper th) {
    padding: 5px 0 !important;
  }
  :deep(.el-table__header-wrapper th .cell) {
    padding: 0 10px;
    line-height: 1.2;
  }
}
.can-replay {
  cursor: pointer;
}
.open-acw-icon {
  font-size: 18px;
  color: #1ab2f2;
  cursor: pointer;
}
.open-acw-icon-no-audio {
  color: #909399;
}
.can-not-replay {
  cursor: not-allowed;
}

.phone_call {
  display: flex;
  align-items: center;
  .phone_call_username {
    margin-left: 10px;
    width: calc(100% - 50px);
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.more-action {
  cursor: pointer;
}
a.download-link {
  color: #000;
  text-decoration: none;
}
a.download-link:hover {
  color:#49b1f3
}
.wav-view-container {
  :deep(.el-table__body .call_start_end .cell){
    word-break: normal;
  }
}
// 横スクロール対応
.wav_view_search_result {
  overflow-x: auto;
  width: 100%;
}
.voice-log-table {
  width: auto;
}
.alert-warning-word {
  // background-color: #ff9a91; 
  // color: red; 
  // float: left; 
  // width: 100%
  // background-color: #ffc107; 
  background-color:#ef5893;;
  color: #000; 
  float: left; 
  width: 100%
}
.alert-long-time {
	// background-color: #996633; 
  background-color: #d5934f;
	color: #000
}
.alert-ng-word {
	// background-color: #ffcdd2; 
  background-color:red;
  // background-color:#fc7d78;
	color: #000; 
	float: left; 
	width: 100%;
}
.alert-wow-word {
	// background-color: #67c23a; 
  background-color:#00bfff;
	color: #000; 
	float: left; 
	width: 100%;
}
.alert-ng-manner {
  background-color:#ff9300;
  color: #000; 
	float: left; 
	width: 100%;
}
::v-deep .col-category .cell {
  // text-align: left !important;
}
// ::v-deep .col-subject .cell {
//   text-align: left !important;
// }
::v-deep th.col-subject .cell {
  text-align: center !important;
}

::v-deep td.col-subject .cell{
  text-align: left !important;
}
::v-deep .el-input__inner {
  /* padding-right: 4px; */
  padding: 0px 8px !important;
}
.text-wrap{
  white-space: pre-line;
}
.alert-acw-content {
  background-color: #80008024;
  border-color: purple;
  color: purple;
}
.el-tg-common {
  border-radius: 16px;
  border-width: 1px;
  font-size: 12px;
  border-style: solid;
  display: inline-block;
  height: 20px;
  padding: 0 10px;
}
</style>

<style lang="scss">
.recording-delete-confirm .el-message-box__btns .el-button {
  padding: 8px 10px;
  font-size: 13px;
}
</style>
